/**
 * HudGrainOverlay — texture grain SVG fixe sur tout le viewport.
 * À placer une fois dans HUDLayout ET LandingPage (z-index bas).
 */
const HudGrainOverlay = () => (
  <div className="hud-grain" aria-hidden="true" />
);

export default HudGrainOverlay;
export { HudGrainOverlay };
